export default [
  {
    name: 'collects',
    path: 'user/collects',
    component: () => import(/* webpackChunkName: "collects" */ '@/views/User/Collects'),
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'orders',
    path: 'user/orders',
    component: () => import(/* webpackChunkName: "orders" */ '@/views/User/Orders'),
    meta: {
      keepAlive: true
    }
  }
]
